// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-c8d8cb8a]{padding:16px 8px!important}.guestbox[data-v-c8d8cb8a]{margin:0 auto;line-height:46px;text-align:left;font-size:16px;color:#676767}.gb-td[data-v-c8d8cb8a]{padding:8px 7px}.age[data-v-c8d8cb8a]{font-size:11px}.btn[data-v-c8d8cb8a]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}", ""]);
// Exports
module.exports = exports;
